import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet } from './api';
import { IbackofficeUserData } from '../types/configuration.types';
const { REACT_APP_API_USERS } = process.env;

/**
 * Trae todos los usuarios desde la API y los guarda en el estado global.
 * @returns {Promise<IbackofficeUserData[]>} Lista de usuarios
 */
export const getAllUsers = async (): Promise<IbackofficeUserData[]> => {
  return apiGet<AxiosRequestConfig, IbackofficeUserData[]>(`${REACT_APP_API_USERS}/user/backoffice/listing`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
